<div class="statement-generator-form-container">
  <form [formGroup]="statementForm" (ngSubmit)="onSubmit()">

    <!-- A. IDENTITÀ (OBBLIGATORIO) -->
    <mat-card class="form-section-card mb-4">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">badge</mat-icon>
          {{ 'components.statement-generator.form.section-identity' | translate }}
          <!-- IDENTITÀ -->
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <!-- Progetto (ereditato) -->
        <div class="subsection mb-4">
          <h6 class="subsection-title">{{ 'components.statement-generator.form.section-project' | translate }}</h6>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.statement-generator.form.project-title' | translate }}</mat-label>
            <input matInput formControlName="projectTitle" >
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.statement-generator.form.therapeutic-area' | translate }}</mat-label>
            <textarea matInput formControlName="therapeuticArea" rows="2" ></textarea>
          </mat-form-field>
        </div>

        <!-- Tipo di expert consultation -->
        <div class="subsection mb-4">
          <h6 class="subsection-title">{{ 'components.statement-generator.form.consultation-type' | translate }}</h6>
          <div formGroupName="consultationType">
            <mat-checkbox formControlName="asynchronousAdvisoryBoard">Asynchronous Advisory Board</mat-checkbox>
            <mat-checkbox formControlName="delphi">Delphi</mat-checkbox>
            <mat-checkbox formControlName="modifiedDelphi">Modified Delphi</mat-checkbox>
            <mat-checkbox formControlName="miniDelphi">Mini-Delphi</mat-checkbox>
            <mat-checkbox formControlName="structuredExpertSurvey">Structured Expert Survey</mat-checkbox>
            <mat-form-field appearance="outline" class="w-100 mt-2">
              <mat-label>{{ 'components.statement-generator.form.consultation-other' | translate }}</mat-label>
              <input matInput formControlName="other">
            </mat-form-field>
          </div>
        </div>

        <!-- Obiettivo -->
        <div class="subsection mb-4">
          <h6 class="subsection-title">{{ 'components.statement-generator.form.section-objective' | translate }}</h6>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.statement-generator.form.project-objective' | translate }}</mat-label>
            <textarea matInput formControlName="surveyObjective" rows="3" required></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.statement-generator.form.specific-focus' | translate }}</mat-label>
            <textarea matInput formControlName="sessionFocus" rows="2"></textarea>
          </mat-form-field>
        </div>

        <!-- Target audience -->
        <div class="subsection mb-4">
          <h6 class="subsection-title">{{ 'components.statement-generator.form.section-target' | translate }}</h6>
          <div formGroupName="targetAudience">
            <mat-form-field appearance="outline" class="w-100 mb-3">
              <mat-label>{{ 'components.statement-generator.form.specialty' | translate }}</mat-label>
              <mat-select formControlName="specialties" multiple>
                @for (specialty of medicalSpecialties; track specialty) {
                  <mat-option [value]="specialty">
                    {{ specialty }}
                  </mat-option>
                }
              </mat-select>
              <mat-hint>{{ 'components.statement-generator.form.specialty-hint' | translate }}</mat-hint>
            </mat-form-field>

            @if (isOtherSpecialtySelected()) {
              <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>{{ 'components.statement-generator.form.specialty-other' | translate }}</mat-label>
                <input matInput formControlName="otherSpecialty" placeholder="Inserisci la specialità">
              </mat-form-field>
            }

            <div class="mb-3">
              <label class="form-label d-block">Seniority:</label>
              <mat-checkbox formControlName="kol" class="mr-3">KOL</mat-checkbox>
              <mat-checkbox formControlName="expertClinicians" class="mr-3">Clinici esperti</mat-checkbox>
              <mat-checkbox formControlName="mix">Mix</mat-checkbox>
            </div>

            <div class="mb-3">
              <label class="form-label d-block">Setting:</label>
              <mat-checkbox formControlName="hub" class="mr-3">Hub</mat-checkbox>
              <mat-checkbox formControlName="spoke" class="mr-3">Spoke</mat-checkbox>
              <mat-checkbox formControlName="mixedSetting">Misto</mat-checkbox>
            </div>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ 'components.statement-generator.form.regulatory-context' | translate }}</mat-label>
              <input matInput formControlName="geography">
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- B. PICO / PICOST -->
    <mat-card class="form-section-card mb-4">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">psychology</mat-icon>
          PICO / PICOST
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <!-- PICO Selection Mode -->
        <div class="mb-4">
          <mat-button-toggle-group [(value)]="picoMode" (change)="onPicoModeChange($event.value)">
            <mat-button-toggle value="existing">
              <mat-icon class="mr-1">folder</mat-icon>
              {{ 'components.statement-generator.form.pico-select-existing' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="new">
              <mat-icon class="mr-1">add</mat-icon>
              {{ 'components.statement-generator.form.pico-create-new' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <!-- Select Existing PICO -->
        @if (picoMode === 'existing' && existingPicos && existingPicos.length > 0) {
          <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>PICO</mat-label>
            <mat-select [(value)]="selectedPicoId" (selectionChange)="onPicoSelected($event.value)">
              <mat-option [value]="null">{{ 'components.statement-generator.form.pico-none' | translate }}</mat-option>
              @for (pico of existingPicos; track pico.id) {
                <mat-option [value]="pico.id">
                  <div class="pico-option">
                    <strong>{{ pico.name || 'PICO ' + pico.id }}</strong>
                    @if (pico.population) {
                      <div class="text-muted small">P: {{ pico.population | slice:0:50 }}...</div>
                    }
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- PICO Form Fields -->
        <div formGroupName="pico">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>P – Population</mat-label>
            <textarea matInput formControlName="population" rows="3"
              placeholder="criteri clinici chiave, linee di trattamento, exposure, sottogruppi rilevanti"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>I – Intervention(s)</mat-label>
            <textarea matInput formControlName="intervention" rows="3"
              placeholder="farmaci, piattaforme, strategie di interesse"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>C – Comparator(s)</mat-label>
            <textarea matInput formControlName="comparator" rows="3"
              placeholder="SOC, alternative rilevanti, 'best available'"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>O – Outcomes prioritari</mat-label>
            <textarea matInput formControlName="outcomes" rows="3"
              placeholder="Es. PFS, OS, ORR, ≥CR, Safety / Infections, QoL / PRO, MRD (soglia)..."></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>S – Studies</mat-label>
            <textarea matInput formControlName="setting" rows="2"
              placeholder="Es. Trial, Real-world, Misto, Review, Linee Guida..."></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>T – Timeframe</mat-label>
            <textarea matInput formControlName="timeframe" rows="2"
              placeholder="Es. Follow-up minimo, orizzonte temporale, data cut-off..."></textarea>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- C. CONTESTO CLINICO & UNMET NEEDS -->
    <mat-card class="form-section-card mb-4">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">medical_services</mat-icon>
          {{ 'components.statement-generator.form.section-clinical-context' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div formGroupName="clinicalContext">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Clinical context / Patient journey</mat-label>
            <textarea matInput formControlName="patientJourney" rows="4"
              placeholder="Dove siamo oggi + cosa sta cambiando; es. DCE storico → popolazioni CD38-exposed"></textarea>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Unmet clinical needs</mat-label>
            <textarea matInput formControlName="unmetNeeds" rows="4"
              placeholder="Es. Efficacy depth (CR / MRD), Durability (PFS / OS / DOR), Safety / Infections..."></textarea>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- D. EVIDENZE DA CONSIDERARE -->
    <mat-card class="form-section-card mb-4">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">library_books</mat-icon>
          {{ 'components.statement-generator.form.section-evidence' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div formGroupName="evidence">
          <!-- Anchor studies -->
          <div class="subsection mb-4">
            <h6 class="subsection-title d-flex justify-content-between align-items-center">
              <span>Anchor studies (3–10 studi chiave)</span>
              <div class="d-flex gap-2">
                <button type="button" mat-raised-button color="primary" (click)="openLiteratureSelector()">
                  <mat-icon>library_books</mat-icon> Select from literature
                </button>
                <!-- Hidden per richiesta utente -->
                <!-- <button type="button" mat-raised-button (click)="addAnchorStudy()">
                  <mat-icon>add</mat-icon> Aggiungi manualmente
                </button> -->
              </div>
            </h6>

            <!-- Show literature selector if open -->
            @if (showLiteratureSelector && analyzedLiterature.length > 0) {
              <div class="literature-selector mb-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h6 class="mb-0">{{ 'components.statement-generator.form.select-study-dialog' | translate }}</h6>
                  <button type="button" mat-stroked-button color="primary" (click)="selectAllLiterature()">
                    <mat-icon>{{ allLiteratureSelected ? 'deselect' : 'select_all' }}</mat-icon>
                    {{ allLiteratureSelected ? 'Deselect all' : 'Select all' }}
                  </button>
                </div>
                <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
                  <table class="table table-hover attachments-table mb-0">
                    <thead>
                      <tr>
                        <th style="width:48px"></th>
                        <th>Type</th>
                        <th>Authors</th>
                        <th>Title</th>
                        <th>Year</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (lit of analyzedLiterature; track lit.id) {
                        <tr [ngClass]="{'row-added': isLiteratureAlreadyAdded(lit.id)}">
                          <td>
                            <mat-checkbox
                              [checked]="isLiteratureSelected(lit.id) || isLiteratureAlreadyAdded(lit.id)"
                              [disabled]="isLiteratureAlreadyAdded(lit.id)"
                              (change)="toggleLiterature(lit, $event.checked)">
                            </mat-checkbox>
                          </td>
                          <td>
                            <span class="type-badge" [ngClass]="lit.type === 'PUBMED' ? 'type-pubmed' : 'type-file'">
                              {{ lit.type === 'PUBMED' ? 'PubMed' : 'File' }}
                            </span>
                          </td>
                          <td class="authors-cell">
                            <span [title]="lit.authors">
                              {{ lit.authors ? ((lit.authors | slice:0:30) + (lit.authors.length > 30 ? '…' : '')) : '-' }}
                            </span>
                          </td>
                          <td class="file-cell">
                            @if (lit.type === 'PUBMED' && lit.link) {
                              <a [href]="lit.link" target="_blank" class="file-title pubmed-link" [title]="lit.title" rel="noopener noreferrer">
                                {{ lit.title ? ((lit.title | slice:0:60) + (lit.title.length > 60 ? '…' : '')) : (lit.name || '-') }}
                                <mat-icon class="external-link-icon">open_in_new</mat-icon>
                              </a>
                            } @else {
                              <span [title]="lit.title">
                                {{ lit.title ? ((lit.title | slice:0:60) + (lit.title.length > 60 ? '…' : '')) : (lit.name || '-') }}
                              </span>
                            }
                            @if (isLiteratureAlreadyAdded(lit.id)) {
                              <span class="badge badge-success ml-1">✓ Added</span>
                            }
                          </td>
                          <td>{{ lit.year || lit.pubyear || '-' }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <div class="d-flex justify-content-end mt-3 gap-2">
                  <button type="button" mat-button (click)="closeLiteratureSelector()">Chiudi</button>
                  <button type="button" mat-raised-button color="primary" (click)="addSelectedLiterature()">
                    Aggiungi selezionati ({{ selectedLiteratureIds.length }})
                  </button>
                </div>
              </div>
            }

            @if (showLiteratureSelector && analyzedLiterature.length === 0) {
              <div class="alert alert-info mb-3">
                <mat-icon class="mr-2">info</mat-icon>
                Nessun documento analizzato trovato. Carica e analizza prima i documenti nella sezione "Letteratura Scientifica".
              </div>
            }

            <div formArrayName="anchorStudies">
              @for (study of anchorStudies.controls; track study; let i = $index) {
                <div [formGroupName]="i" class="anchor-study-item">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h6 class="mb-0">Study {{ i + 1 }}</h6>
                    <button type="button" mat-icon-button color="warn" (click)="removeAnchorStudy(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Study / PMID / DOI / NCT</mat-label>
                    <input matInput formControlName="reference">
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'components.statement-generator.form.why-relevant' | translate }}</mat-label>
                    <input matInput formControlName="relevance">
                  </mat-form-field>
                </div>
              }
            </div>
            @if (anchorStudies.controls.length === 0) {
              <div class="alert alert-info">
                <mat-icon class="mr-2">info</mat-icon>
                {{ 'components.statement-generator.form.select-study-nostudy' | translate }}
                <!-- Nessuno studio ancora aggiunto. Clicca su "Seleziona da letteratura" per iniziare. -->
              </div>
            }
          </div>

          <!-- Tipologie di evidenza -->
          <!-- <div class="mb-3">
            <label class="form-label d-block mb-2">{{ 'components.statement-generator.form.section-evidence' | translate }}</label>
            <div formGroupName="evidenceTypes">
              <mat-checkbox formControlName="guidelines">Linee guida / Meta-analisi / Systematic reviews</mat-checkbox>
              <mat-checkbox formControlName="rct">RCT / Trial registrativi</mat-checkbox>
              <mat-checkbox formControlName="phase2">Trial fase 2</mat-checkbox>
              <mat-checkbox formControlName="phase1">Trial fase 1</mat-checkbox>
              <mat-checkbox formControlName="realWorld">Real-World Evidence</mat-checkbox>
              <mat-checkbox formControlName="comparative">Comparative / MAIC / indiretti</mat-checkbox>
              <mat-checkbox formControlName="biological">Razionale biologico / horizon scan (solo se consentito)</mat-checkbox>
            </div>
          </div> -->

          <!-- Esclusioni -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Esclusioni</mat-label>
            <textarea matInput formControlName="exclusions" rows="3"
              placeholder='es. "Non includere linee guida italiane in questa Survey"'></textarea>
          </mat-form-field>

          <!-- Fonti interne Butterfly -->
          <div class="mb-3">
            <label class="form-label d-block mb-2">Fonti interne Butterfly</label>
            <mat-checkbox formControlName="previousSurveys" (change)="onPreviousSurveysCheckboxChange($event.checked)">
              Survey precedenti dalla stessa organizzazione
            </mat-checkbox>

              <!-- Survey Selector Modal -->
              @if (showSurveySelector) {
                <div class="survey-selector mt-3">
                  <mat-card>
                    <mat-card-content>
                      <h6 class="mb-3">{{ 'components.statement-generator.form.select-survey-dialog' | translate }}</h6>
                      <p class="text-muted small">Verranno importati: titolo, descrizione, domande e risposte</p>

                      <div class="survey-list" style="max-height: 400px; overflow-y: auto;">
                        @for (survey of previousSurveysAvailable; track survey.id) {
                          <div class="survey-item">
                            <mat-checkbox
                              [checked]="isSurveySelected(survey.id)"
                              (change)="toggleSurvey(survey, $event.checked)">
                              <div class="survey-content">
                                <strong>{{ survey.title }}</strong>
                                @if (survey.description) {
                                  <div class="text-muted small mt-1">{{ survey.description | slice:0:100 }}...</div>
                                }
                                <div class="survey-meta mt-1">
                                  @if (survey.questions_count) {
                                    <span class="badge badge-info mr-2">{{ survey.questions_count }} domande</span>
                                  }
                                  @if (survey.responses_count) {
                                    <span class="badge badge-success">{{ survey.responses_count }} risposte</span>
                                  }
                                  @if (survey.status) {
                                    <span class="badge badge-secondary ml-2">{{ survey.status }}</span>
                                  }
                                </div>
                              </div>
                            </mat-checkbox>
                          </div>
                        }
                      </div>

                      <div class="d-flex justify-content-end mt-3 gap-2">
                        <button type="button" mat-button (click)="closeSurveySelector()">Chiudi</button>
                        <button type="button" mat-raised-button color="primary" (click)="importSelectedSurveys()">
                          Importa selezionate ({{ selectedSurveyIds.length }})
                        </button>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
              }

              <!-- Display Imported Surveys -->
              @if (importedSurveys.length > 0) {
                <div class="imported-surveys mt-3">
                  <h6 class="mb-2">Survey importate ({{ importedSurveys.length }})</h6>
                  @for (survey of importedSurveys; track survey.id) {
                    <div class="imported-survey-card">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                          <strong>{{ survey.title }}</strong>
                          @if (survey.description) {
                            <div class="text-muted small">{{ survey.description }}</div>
                          }
                          <div class="survey-stats mt-2">
                            <span class="badge badge-info mr-2">{{ survey.questions?.length || 0 }} domande</span>
                            <span class="badge badge-success">{{ survey.responses?.length || 0 }} risposte</span>
                          </div>
                        </div>
                        <button type="button" mat-icon-button color="warn" (click)="removeImportedSurvey(survey.id)">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- E. OUTPUT CONSTRAINTS -->
    <mat-card class="form-section-card mb-4">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">tune</mat-icon>
          OUTPUT
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" style="width: 200px;">
          <mat-label>Numero di statement</mat-label>
          <input matInput type="number" formControlName="targetStatements" min="1" max="30">
          @if (statementForm.get('targetStatements')?.hasError('min')) {
            <mat-error>Il valore minimo è 1</mat-error>
          }
          @if (statementForm.get('targetStatements')?.hasError('max')) {
            <mat-error> Max value 20 </mat-error>
          }
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <!-- F. CONTROLLI DI COMPLIANCE & STILE -->
    <mat-card class="form-section-card mb-4">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">security</mat-icon>
          {{ 'components.statement-generator.form.section-compliance' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div formGroupName="compliance">

          <!-- Strict evidence mode -->
          <div class="compliance-toggle mb-4">
            <div class="d-flex align-items-center mb-1">
              <mat-slide-toggle formControlName="strictEvidenceMode" color="primary">
                <strong>{{ 'components.statement-generator.form.compliance-strict-evidence-mode' | translate }}</strong>
              </mat-slide-toggle>
            </div>
            <!-- <p class="text-muted small mb-1">Ogni statement deve avere almeno un riferimento esplicito (PMID / DOI / NCT o file)</p>
            <p class="text-muted small mb-0"><em>Effetto: il modello NON genera statement opinion-based; se non trova evidenza → lo statement non viene generato</em></p> -->
          </div>

          <!-- Minimize off-label tone -->
          <div class="compliance-toggle mb-4">
            <div class="d-flex align-items-center mb-1">
              <mat-slide-toggle formControlName="minimizeOffLabelTone" color="primary">
                <strong>{{ 'components.statement-generator.form.compliance-minimize-off-label' | translate }}</strong>
              </mat-slide-toggle>
            </div>
            <!-- <p class="text-muted small mb-1">Usa linguaggio condizionale e non prescrittivo per dati non approvati</p>
            <p class="text-muted small mb-0"><em>Effetto: "may", "could", "suggests", "potentially" — evita "should", "represents a new standard", "preferred treatment"</em></p> -->
          </div>

          <!-- Epistemic transparency level -->
          <div class="compliance-toggle mb-2">
            <label class="form-label d-block mb-2"><strong>{{ 'components.statement-generator.form.compliance-epistemic-transparency' | translate }}</strong></label>
            <mat-radio-group formControlName="epistemicTransparency" class="d-flex flex-column gap-2">
              <mat-radio-button value="base">
                {{ 'components.statement-generator.form.compliance-epistemic-base' | translate }}
              </mat-radio-button>
              <mat-radio-button value="standard">
                {{ 'components.statement-generator.form.compliance-epistemic-standard' | translate }}
              </mat-radio-button>
              <mat-radio-button value="advanced">
                {{ 'components.statement-generator.form.compliance-epistemic-advanced' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- G. REGOLE EDITORIALI AVANZATE -->
    <mat-card class="form-section-card mb-4" style="display: none;">
      <mat-card-header>
        <mat-card-title class="section-title">
          <mat-icon class="mr-2">edit_note</mat-icon>
          {{ 'components.statement-generator.form.section-editorial-rules' | translate }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div formGroupName="editorialRules">

          <!-- Tono editoriale -->
          <div class="mb-4">
            <label class="form-label d-block mb-2"><strong>{{ 'components.statement-generator.form.editorial-tone' | translate }}</strong></label>
            <mat-checkbox formControlName="toneNeutral" class="mr-3">{{ 'components.statement-generator.form.editorial-tone-neutral' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="toneDiscussion" class="mr-3">{{ 'components.statement-generator.form.editorial-tone-discussion' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="toneNonPromotional" class="mr-3">{{ 'components.statement-generator.form.editorial-tone-non-promotional' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="toneNoSuperlatives">{{ 'components.statement-generator.form.editorial-tone-no-superlatives' | translate }}</mat-checkbox>
          </div>

          <!-- Evidence grading preferito -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.statement-generator.form.editorial-evidence-grading' | translate }}</mat-label>
            <input matInput formControlName="evidenceGrading"
              [placeholder]="'components.statement-generator.form.editorial-evidence-grading-placeholder' | translate">
          </mat-form-field>

          <!-- Regole di granularità -->
          <div class="mb-4">
            <label class="form-label d-block mb-2"><strong>{{ 'components.statement-generator.form.editorial-granularity' | translate }}</strong></label>
            <div class="d-flex flex-column">
              <mat-checkbox formControlName="granularitySingleConcept">{{ 'components.statement-generator.form.editorial-granularity-single-concept' | translate }}</mat-checkbox>
              <mat-checkbox formControlName="granularityNoRedundancy">{{ 'components.statement-generator.form.editorial-granularity-no-redundancy' | translate }}</mat-checkbox>
            </div>
          </div>

          <!-- Glossario / definizioni operative -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'components.statement-generator.form.editorial-glossary' | translate }}</mat-label>
            <input matInput formControlName="glossary"
              [placeholder]="'components.statement-generator.form.editorial-glossary-placeholder' | translate">
          </mat-form-field>

        </div>
      </mat-card-content>
    </mat-card>

    <!-- Form Actions -->
    <div class="form-actions text-center mb-4">
      <button type="button" mat-stroked-button class="mr-3" (click)="onCancel()">
        <mat-icon>cancel</mat-icon>
        Annulla
      </button>
      <!-- Hidden per richiesta utente -->
      <!-- <button type="button" mat-raised-button class="mr-3" (click)="onSaveDraft()">
        <mat-icon>save</mat-icon>
        Salva bozza
      </button> -->
      <button type="submit" mat-raised-button color="primary" [disabled]="!statementForm.valid || isSubmitting">
        @if (!isSubmitting) {
          <mat-icon>auto_awesome</mat-icon>
        }
        @if (isSubmitting) {
          <mat-spinner diameter="20" class="mr-2" style="display: inline-block;"></mat-spinner>
        }
        {{ isSubmitting ? 'Generazione in corso...' : 'Genera Statements' }}
      </button>
    </div>

    <!-- Progress indicator -->
    @if (isSubmitting) {
      <mat-card class="progress-card">
        <mat-card-content>
          <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
          <p class="text-center mt-3">{{ progressMessage }}</p>
        </mat-card-content>
      </mat-card>
    }
  </form>
</div>
